import { adminAuthApi } from './auth'
import { adminUserApi } from './user'
import { adminPlaceApi } from './place'
import { adminReviewApi } from './review'
import { adminReportApi } from './report'
import { adminInquiryApi } from './inquiry'
import { adminNoticeApi } from './notice'
import { adminReviewKeywordApi } from './reviewKeyword'
import { adminMapApi } from './map'
import { adminPlaceCategoryApi } from './placeCategory'
import { adminDefaultReviewCategoryApi } from './defaultReviewCategory'
import { adminPushApi } from './push'
import { adminPolicyApi } from './policy'
import { adminAppVersionApi } from './appVersion'
import { adminCuratedFeedApi } from './curatedFeed'
import { adminInstagramTestApi } from './instagramTest'
import { adminPlaceNameAuditApi } from './placeNameAudit'

export const adminApi = {
  ...adminAuthApi,
  curatedFeed: adminCuratedFeedApi,
  ...adminUserApi,
  ...adminPlaceApi,
  ...adminReviewApi,
  ...adminReportApi,
  ...adminInquiryApi,
  ...adminNoticeApi,
  ...adminReviewKeywordApi,
  ...adminMapApi,
  ...adminPlaceCategoryApi,
  ...adminDefaultReviewCategoryApi,
  ...adminPushApi,
  ...adminPolicyApi,
  ...adminAppVersionApi,
  ...adminInstagramTestApi,
  ...adminPlaceNameAuditApi,
}
